// Settings configured here will be merged into the final config object.

/* rating values
Strongly agree – stimme voll und ganz zu
Agree – stimme grösstenteils zu
Tend to agree – stimme teilweise zu
Neither agree nor disagree – weder noch
Tend to disagree – stimme teilweise nicht zu
Disagree – stimme grösstenteils nicht zu
Strongly disagree – stimme überhaupt nicht zu
 */

import { Axis } from 'types/Axis'
import { IAnswer } from 'types/IAnswer'
import { LinkedChainNavigation } from '../components/linkedChainNavigation/linkedChainNavigation'
import responseList from './responses.yml'
import values from './values.yml'

/** Responses and their values */
const responses: Array<[string, number]> = []
const revertedResponses: Array<[string, number]> = []

responseList.forEach((response: string, index: number) => {
  responses.push([response, values[index]])
  revertedResponses.push([response, values[values.length - 1 - index]])
})

/** Database endpoint */
const dbEndpoint = 'https://populisten-quiz-2019.firebaseio.com'

/** The domain for the Y axis (populism) */
const domainY: [number, number] = [24, -24]

/** The domain for the X axis (conservatism) */
const domainX: [number, number] = [-36, 36]

/**
 * Calculate the total score for a desired axis from the collected answers.
 * @param {IAnswer[]} answers
 * @param {'conservatism'|'populism'} axis
 */
function getScoreFor(answers: IAnswer[], axis: Axis): number {
  return answers
    .filter(answer => answer.axis === axis)
    .reduce(
      (previousValue: number, currentValue: IAnswer) =>
        previousValue + currentValue.answer,
      0
    )
}

export default {
  LinkedChainNavigation,
  dbEndpoint,
  domainX,
  domainY,
  getScoreFor,
  responses,
  revertedResponses
}
